import { appUrls } from "helpers/Urls";
import axiosInstance from "utils/axiosInstance";

const fetchReportData = async (patientId, daysAgo) => {
  const url = +daysAgo === 365 ? appUrls.GlucoseChart(patientId, 365) : appUrls.GlucoseChartAll(patientId);

  const { data } = await axiosInstance.get(url);
  return data;
};

export default fetchReportData;